import { render, staticRenderFns } from "./AttributesView.vue?vue&type=template&id=7d8a67eb&scoped=true"
import script from "./AttributesView.vue?vue&type=script&lang=js"
export * from "./AttributesView.vue?vue&type=script&lang=js"
import style0 from "./AttributesView.vue?vue&type=style&index=0&id=7d8a67eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8a67eb",
  null
  
)

export default component.exports